import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Game } from '../../../core/models/game.model';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { RouterLink } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { PRICE } from '../../constants/tokens';
import { MatIcon } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";

@Component({
  selector: 'app-game-card',
  templateUrl: './game-card.component.html',
  styleUrls: ['./game-card.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    RouterLink,
    TranslatePipe,
    MatIcon,
    MatTooltipModule
],
})
export class GameCardComponent {
  @Input() game!: Game;
  @Input() urlLangPart: string = '';
  @Output() startGame = new EventEmitter<number>();
  @Input() loading = false;
  @Input() whiteStyle = false;

  public cdn = environment.cdnUrl;
  public cost = PRICE.PAID_GAME_COST;

  public onStartGame(gameId: number) {
    if (this.loading) return;
    this.startGame.emit(gameId);
  }
}
